<template>
  <div class="convenience-service">
    <HomeTitle :data="titleData" @moreHandle="moreHandle"></HomeTitle>
    <div class="service-container">
      <div class="service-box" v-for="(item, index) in data" :key="index" @click="locationTo(item.busurl)">
        <span class="iconbox">
            <img
              class="icon-img"
              onload="SVGInject(this)"
              round fit="cover"
              :src="complete(item.buspic)"
            />
        </span>
        <p class="service-name">{{ item.busname }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {complete, baseURL} from "@/utils/url"
import * as svg from '@/utils/svg-inject.min'
import { queryConvenienceService } from '@/api/home/index'
import {locationTo} from "@/utils/url"
export default {
  name: "ConvenienceServices",
  components: {
    HomeTitle: () => import('./HomeTitle')
  },
  props: ['title'],
  data() {
    return {
      titleData: {
        title: this.title,
        more: false
      },
      data: []
    }
  },
  created() {
    this.getThematicServiceList();
  },
  methods: {
    complete,
    locationTo,
    // 获取服务列表
    getThematicServiceList() {
      queryConvenienceService().then(res => {
        if (res && res.code == 200) {
          this.data = res.data;
        }
      })
    },
    // 更多点击事件
    moreHandle() {
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/theme/theme.scss';
.service-container {
  padding: 15px 0;
  display: flex;
  flex-wrap: wrap;
  .service-box {
    position: relative;
    width: 107px;
    height: 100px;
    padding: 20px 10px;
    margin-right: 12px;
    margin-bottom: 12px;
    box-sizing: border-box;
    border-radius: 5px;
    text-align: center;
    background: #F3F5FF;
    box-shadow: 0 0 8px 0 rgba(25, 137, 250, .1);
    flex-shrink: 0;
    &:nth-child(3n){
      margin:0;
    }
    .iconbox {
      display: block;
      width: 24px;
      height: 24px;
      margin: 0 auto 15px;
      
      img,svg {
        display: block;
        width: 24px;
        height: 24px;
        fill: #003d88;
      }
    }
    
    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      &.service-name {
        height: 25px;
        line-height: 25px;
        @extend .font16;
      }
      
      &.service-describe {
        height: 23px;
        line-height: 23px;
        @extend .font13;
      }
    }
    
    .graphics {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
    
    .graphics01 {
      left: 0;
      -webkit-animation: project-animation01 5s linear infinite;
      -o-animation: project-animation01 5s linear infinite;
      animation: project-animation01 5s linear infinite;
    }
    
    .graphics02 {
      right: 0;
      -webkit-animation: project-animation02 5s linear infinite;
      -o-animation: project-animation02 5s linear infinite;
      animation: project-animation02 5s linear infinite;
    }
    
    @keyframes project-animation01 {
      0%,100% {
        -webkit-transform: translate(0, 0);
        -moz-transform: translate(0, 0);
        -ms-transform: translate(0, 0);
        -o-transform: translate(0, 0);
        transform: translate(0, 0);
      }
      50% {
        -webkit-transform: translate(0, 10px);
        -moz-transform: translate(0, 10px);
        -ms-transform: translate(0, 10px);
        -o-transform: translate(0, 10px);
        transform: translate(0, 10px);
      }
    }
    
    @keyframes project-animation02 {
      0%,100% {
        -webkit-transform: translate(0, 0);
        -moz-transform: translate(0, 0);
        -ms-transform: translate(0, 0);
        -o-transform: translate(0, 0);
        transform: translate(0, 0);
      }
      50% {
        -webkit-transform: translate(20px, 10px);
        -moz-transform: translate(20px, 10px);
        -ms-transform: translate(20px, 10px);
        -o-transform: translate(20px, 10px);
        transform: translate(20px, 10px);
      }
    }
  }
}

</style>
